import React, { memo, useContext } from "react";
import { any, node, string } from "prop-types";
import { ThemeContext } from "styled-components";
import { Container } from "reactstrap";

import { Text } from "../text";
import { Gray } from "constants/colors";

function Step({
  children,
  headerTitle,
  headerSubtitle,
  title,
  subtitle,
  style,
  headerStyle = {},
}) {
  const theme = useContext(ThemeContext);
  return (
    <main
      style={{
        height: "100vh",
      }}
    >
      <header
        style={{
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.newPalette.background.gray[300],
          padding: 20,
          height: 92,
          marginBottom: 22,
          display: "flex",
          justifyContent: "center",
          background: Gray[100],
          flexDirection: "column",
          ...headerStyle
        }}
      >
        <p
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: theme.newPalette.typography[100],
          }}
        >
          { headerTitle || "Dados Cadastrais" }
        </p>
        {
          headerSubtitle && (
            <Text
              fontSize="15px"
              color={theme.newPalette.typography[200]}
              fontWeight="400"
            >
              {headerSubtitle}
            </Text>
          )
        }
      </header>
      <Container fluid style={style}>
        {title && (
          <Text
            fontSize="22px"
            fontWeight="400"
            fontHeight="24px"
            whiteSpace="normal"
            margin="0 0 40px 0"
            theme={theme}
          >
            {title}
          </Text>
        )}
        {subtitle && (
          <Text
            fontSize="16px"
            color={theme.colors.text.paragraph}
            fontWeight="400"
            fontHeight="24px"
            whiteSpace="normal"
            margin="0 0 16px 0"
            theme={theme}
          >
            {subtitle}
          </Text>
        )}
        {children}
      </Container>
    </main>
  );
}

Step.defaultProps = {
  style: null,
  title: null,
  subtitle: null,
};

Step.propTypes = {
  children: node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: any,
  title: string,
  subtitle: string,
};

export default memo(Step);
